import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../services/dashboardApi';

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard-stats'],
    queryFn: () => dashboardApi.getStats(),
    staleTime: 60 * 1000, // 1 min: datos "frescos" sin refetch
    refetchInterval: 5 * 60 * 1000, // refresca cada 5 min automáticamente
    refetchOnWindowFocus: true,
  });
}
